export const SERVICE_CODE = 'CUSTOMER' + '_CATEGORY' + '_SERVICE';
